// <sm-upsell-modal>: opens after a successful subscribe add-to-cart for a single formula
// that has an upgrade stack (HANDOFF 7.6). Not for stacks, not for one-time purchases.
import { on, emit, trapFocus, lockScroll } from './sm-core.js';

class SmUpsellModal extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;
    this.currentVariant = this.dataset.currentVariant;
    this.stackVariant = this.dataset.stackVariant;
    this.shownThisSession = false;

    this.onCartAdded = (e) => this.maybeOpen(e.detail);
    this.onClose = () => this.close();
    this.onAccept = () => this.accept();
    this.onKeydown = (e) => {
      if (e.key === 'Escape') this.close();
    };

    this.offCartAdded = on('sm:cart:added', this.onCartAdded);
    this.querySelector('[data-upsell-close]')?.addEventListener('click', this.onClose);
    this.querySelector('[data-upsell-decline]')?.addEventListener('click', this.onClose);
    this.querySelector('[data-upsell-accept]')?.addEventListener('click', this.onAccept);
    this.dialog.addEventListener('cancel', (e) => {
      e.preventDefault();
      this.close();
    });
  }

  disconnectedCallback() {
    this.offCartAdded?.();
    this.releaseFocus?.();
  }

  maybeOpen(cartResponse) {
    if (!this.hasAttribute('data-auto-open')) return;
    if (this.shownThisSession) return;
    const item = cartResponse?.items?.[0];
    if (!item) return;
    const addedThisProduct = String(item.variant_id) === String(this.currentVariant);
    const wasSubscribed = Boolean(item.selling_plan_allocation);
    if (!addedThisProduct || !wasSubscribed) return;
    this.shownThisSession = true;
    this.lastAddedSellingPlan = item.selling_plan_allocation?.selling_plan?.id;
    this.open();
  }

  open() {
    if (this.dialog.open) return;
    this.dialog.showModal();
    lockScroll(true);
    this.releaseFocus = trapFocus(this.dialog);
    document.addEventListener('keydown', this.onKeydown);
  }

  close() {
    if (!this.dialog.open) return;
    this.dialog.close();
    lockScroll(false);
    this.releaseFocus?.();
    document.removeEventListener('keydown', this.onKeydown);
    emit('sm:upsell:done', {});
  }

  async accept() {
    const btn = this.querySelector('[data-upsell-accept]');
    btn?.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.currentVariant, quantity: 0 }),
      });
      const item = { id: this.stackVariant, quantity: 1 };
      if (this.lastAddedSellingPlan) item.selling_plan = this.lastAddedSellingPlan;
      await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] }),
      });
      emit('sm:cart:updated', {});
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('sm-upsell-modal: upgrade failed', err);
    } finally {
      btn?.removeAttribute('aria-busy');
      this.close();
    }
  }
}
if (!customElements.get('sm-upsell-modal')) customElements.define('sm-upsell-modal', SmUpsellModal);
